import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const AppleScaleSmall = hoc(
    (props: IconProps) => (
        <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.9102 4.17023C9.65032 4.17023 9.11786 4.78893 8.24042 4.78893C7.34049 4.78893 6.65429 4.17398 5.56312 4.17398C4.49445 4.17398 3.35453 4.84518 2.63084 5.98884C1.61466 7.60122 1.78715 10.6385 3.43328 13.2258C4.02198 14.152 4.80943 15.1907 5.8406 15.2019H5.85935C6.75553 15.2019 7.02176 14.5982 8.25542 14.5907H8.27417C9.48908 14.5907 9.73281 15.1982 10.6252 15.1982H10.644C11.6752 15.1869 12.5039 14.0358 13.0926 13.1133C13.5163 12.4496 13.6738 12.1159 14 11.3659C11.6189 10.436 11.2365 6.96377 13.5913 5.63262C12.8713 4.70644 11.8627 4.17023 10.9102 4.17023Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
            <path
                d="M10.6323 0.799805C9.88232 0.852301 9.00864 1.34351 8.49493 1.98472C8.02996 2.56592 7.64749 3.42836 7.79748 4.26455H7.85747C8.65616 4.26455 9.4736 3.76959 9.94982 3.13588C10.411 2.53218 10.7598 1.67724 10.6323 0.799805Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Apple'
);
export default AppleScaleSmall;
